import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EndpointService} from './endpoint.service';
import {map, of, shareReplay} from 'rxjs';
import {ShopSummaryListResponse} from '../responses/cashback/ShopSummaryListResponse';
import {ShopDetailsResponse} from '../responses/cashback/ShopDetailsResponse';
import {ShopSummary} from '../models/shopSummary';
import {CashbackLinkResponse} from '../responses/cashback/CashbackLinkResponse';

@Injectable({
  providedIn: 'root'
})
export class CashbackService {

  private shopSummaryCache: Array<ShopSummary> = null;
  private shopDetailsCache: any = {};

  constructor(private http: HttpClient) {
  }

  public getSummaryForShops = () => {
    if (this.shopSummaryCache !== undefined && this.shopSummaryCache !== null) {
      return of(this.shopSummaryCache);
    }

    return this.http.get<ShopSummaryListResponse>(EndpointService.getCashbackShopList)
      .pipe(map(response => {
        const shops = response.responseObject;
        if (shops && shops.length > 0) {
          this.shopSummaryCache = shops;
        }
        return response.responseObject;
      })).pipe(shareReplay());
  };
  public getShopDetails = (shopId: string) => {
    if (this.shopDetailsCache && this.shopDetailsCache[shopId]) {
      return of(this.shopDetailsCache[shopId]);
    }

    return this.http.get<ShopDetailsResponse>(EndpointService.getCashbackShopDetails(shopId))
      .pipe(map(response => {
        const shop = response.responseObject;
        if (shop) {
          this.shopDetailsCache[shop.id] = shop;
        }
        shop.coupons.forEach(c => {
          if (c.title && c.title.trim().length > 0){
            c.slug = this.slugify(c.title);
          } else {
            c.slug = shop.id +'-' + c.discountPercent + '-' + c.code + '-' + c.endDate;
          }
        });
        return shop;
      })).pipe(shareReplay());
  };

  private slugify = (text: string, separator = '-') => text
    .toString()
    .normalize('NFD')                   // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, '')   // remove all previously split accents
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, '')   // remove all chars not letters, numbers and spaces (to be replaced)
    .trim()
    .replace(/\s+/g, separator);

  getCashbackLink(shopId: string) {
    return this.http.post<CashbackLinkResponse>(EndpointService.getCashbackLink(shopId), null).pipe(map(response => response.responseObject));
  }
}
